import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import Odometer from 'static/script/libs/odometer';

function CustomResultPageUi() {
    let odometer;
    let updateTimer;
    let earningsId;
    let updateTimerInterval = 5000;
    let previousRequestHasResponded = true;
    let nrOfFailures = 0;


    this.defaultAttrs({
        tickerSelector: '[data-earnings-ticker]',
        tickerInitialValueDataAttribute: 'earnings-ticker-initial-value'
    });

    this._initTicker = function () {

        let container = this.select('tickerSelector')[0];
        let jContainer = $(container);

        let tickerInitialValue = jContainer.data(this.attr.tickerInitialValueDataAttribute);
        earningsId = jContainer.data('earnings-ticker');

        odometer = new Odometer({
            el: container,
            value: tickerInitialValue,
            theme: 'train-station',
            format: '(.ddd).dd',
            duration: 2000
        });

        setTimeout(this._requestTickerStatus.bind(this), updateTimerInterval);
    };

    this._requestTickerStatus = function () {
        if (previousRequestHasResponded === true) {
            this.trigger(document, 'ui:campaign:ticker-on-updating', { id: earningsId, url: 'https://www.tradera.com/cache/kampanjer/earningsticker/earnings?campaigncodeids=' + earningsId });
            previousRequestHasResponded = false;
        }

        updateTimer = setTimeout(this._requestTickerStatus.bind(this), updateTimerInterval);
    };

    this._updateTicker = function (evt, data) {
        nrOfFailures--;
        odometer.update(data.total);
        previousRequestHasResponded = true;
    };

    this._tickerFailed = function () {
        if (++nrOfFailures > 2) {
            this._shutDownTicker();
        } else {
            previousRequestHasResponded = true;
        }
    };

    this._shutDownTicker = function () {
        if (updateTimer) {
            clearInterval(updateTimer);
        }
    };

    this._doTeardown = function () {
        updateTimer = null;
        odometer = null;
    };

    this.after('initialize', function () {
        this._initTicker();
        this.on(document, 'ui:campaign:ticker-updated', this._updateTicker);
        this.on(document, 'ui:teardown', this._doTeardown);
        this.on(document, 'ui:campaign:ticker-failure', this._tickerFailed);
    });
}

module.exports = defineComponent.component(CustomResultPageUi);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/custom-result-page-ui.js